"use strict";
// ChannelOpenErrorType + Addtional types for Blocktank-lsp-http
// import {ChannelOpenErrorType} from '@synonymdev/blocktank-lsp-ln2-client'
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtChannelOrderErrorType = void 0;
var BtChannelOrderErrorType;
(function (BtChannelOrderErrorType) {
    /**
     * Order is not in the right state to open a channel. Should be `order.state`=`created` and `order.payment.state`=`paid`.
     */
    BtChannelOrderErrorType["WRONG_ORDER_STATE"] = "WRONG_ORDER_STATE";
    /**
     * Could not establish connection to peer.
     * */
    BtChannelOrderErrorType["PEER_NOT_REACHABLE"] = "PEER_NOT_REACHABLE";
    /**
     * Peer rejected channel open request.
     */
    BtChannelOrderErrorType["CHANNEL_REJECTED_BY_DESTINATION"] = "CHANNEL_REJECTED_BY_DESTINATION";
    /**
     * LSP rejected channel open request.
     */
    BtChannelOrderErrorType["CHANNEL_REJECTED_BY_LSP"] = "CHANNEL_REJECTED_BY_LSP";
    /**
     * Blocktank service is temporarily unavailable.
     */
    BtChannelOrderErrorType["BLOCKTANK_NOT_READY"] = "BLOCKTANK_NOT_READY";
})(BtChannelOrderErrorType = exports.BtChannelOrderErrorType || (exports.BtChannelOrderErrorType = {}));
//# sourceMappingURL=BtChannelOpenErrorType.js.map